import {on} from "../jsbase/events";
var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {},

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function ($rowElem) {
                var rowId = $rowElem.data('id');
                return {id: rowId, el: $rowElem, isDeleted: $rowElem.is('.inactive'), hasWriteAccess: $rowElem.is('.access-w')};
            },
            actions: [{
                name: 'Löschen',
                classNames: 'dropdown-item',
                iconClass: 'bi-trash text-danger',
                onClick: this.onPriceDelete,
                isShown: (row) => row.el.is('[data-obj="PositionPrice"]'),
            }, {
                name: 'Löschen',
                classNames: 'dropdown-item',
                iconClass: 'bi-trash text-danger',
                onClick: this.onDelete,
                isShown: (row) => row.el.is('[data-obj="Position"]'),
            }, {
                name: 'Hinzufügen oberhalb',
                classNames: 'dropdown-item',
                iconClass: 'bi-plus-circle',
                onClick: this.onAddPositionBefore,
                isShown: (row) => row.el.is('[data-obj="Position"]'),
            }, {
                name: 'Hinzufügen unterhalb',
                classNames: 'dropdown-item',
                iconClass: 'bi-plus-circle',
                onClick: this.onAddPositionAfter,
                isShown: (row) => row.el.is('[data-obj="Position"]'),
            }, {
                name: 'Position kopieren',
                classNames: 'dropdown-item',
                iconClass: 'bi-clipboard',
                onClick: this.onCopyPosition,
                isShown: (row) => row.el.is('[data-obj="Position"]'),
            }, {
                name: 'Unterposition hinzufügen',
                classNames: 'dropdown-item',
                iconClass: 'bi-plus-circle',
                onClick: this.onAddPositionBelow,
                isShown: (row) => row.el.is('[data-obj="Position"]'),
            }, {
                name: 'Neu laden',
                classNames: 'dropdown-item',
                iconClass: 'bi-arrow-repeat',
                onClick: this.onReloadPosition,
                isShown: (row) => row.el.is('[data-obj="Position"]'),
            }, {
                name: 'Alle Positionen öffnen',
                classNames: 'dropdown-item',
                iconClass: 'bi-box-arrow-down-right',
                onClick: this.onOpenAllSubPositions,
                isShown: (row) => row.el.is('[data-obj="Position"]'),
            }, {
                name: 'Nach Excel exportieren',
                classNames: 'dropdown-item',
                iconClass: 'bi-file-earmark-spreadsheet',
                onClick: this.onExportPosition,
                isShown: (row) => row.el.is('[data-obj="Position"]'),
            }, {
                name: 'Preis-Position hinzufügen',
                classNames: 'dropdown-item',
                iconClass: 'bi-plus',
                onClick: this.onAddPricePosition,
                isShown: (row) => row.el.is('[data-obj="Position"]') && row.el.hasClass('leaf'),
            }],
        });
    },

    events: [{
        name: 'template.part-loaded',
        el() {
            return document;
        },
        handler(ev) {
            ev.detail.container[0].querySelectorAll('.btn-context-click').forEach((el) => {
                on(el, 'click', (cev) => {
                    cev.preventDefault();
                    cev.stopPropagation();
                    var rowEl = $(cev.target).closest(this.selector);
                    this.menu.open(rowEl, cev);
                });
            });
        },
    }],

    methods: {
        onPriceDelete(row) {
            template.deletePricePosition(row.el);
        },
        onDelete(row) {
            template.deletePosition(row.el);
        },
        onAddPositionBefore(row) {
            template.addPosition(row.el, 'before');
        },
        onAddPositionAfter(row) {
            template.addPosition(row.el, 'after');
        },
        onAddPositionBelow(row) {
            template.addPosition(row.el, 'inside');
        },
        onCopyPosition(row) {
            template.copyPosition(row.el);
        },
        onReloadPosition(row) {
            template.reloadPosition(row.el);
        },
        onOpenAllSubPositions(row) {
            template.openAllSubPositions(row.el);
        },
        onExportPosition(row) {
            template.exportPosition(row.el);
        },
        onAddPricePosition(row) {
            template.addPricePosition(row.el);
        },
    },

}
